import { z } from 'zod';

export const GetReverseProposalGoodsDetailServiceRequestSchema = z
  .object({
    goodsNo: z.number(),
  })
  .describe('GetReverseProposalGoodsDetailServiceRequestSchema');

export type GetReverseProposalGoodsDetailServiceRequest = z.infer<
  typeof GetReverseProposalGoodsDetailServiceRequestSchema
>;

export const GetReverseProposalGoodsDetailServiceResponseSchema = z.object({
  goodsNo: z.number(),
  imageUrl: z.string(),
  brandId: z.string(),
  brandName: z.string(),
  goodsName: z.string(),
  salesRate: z.number(),
  price: z.number(),
  isSoldOut: z.boolean(),
});

export type GetReverseProposalGoodsDetailServiceResponse = z.infer<
  typeof GetReverseProposalGoodsDetailServiceResponseSchema
>;
